import Checkbox from '@material-ui/core/Checkbox';
import React from 'react';
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";

class CheckboxField extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            checked: false
        };
    };

    componentWillReceiveProps(props) {
        this.setState({checked: this.props.checked});
    }

    componentDidMount(){
        if(this.props.form.courses){
            const previouslyCheckedCourse = this.getPreviouslyChecked();
            this.setState({checked:previouslyCheckedCourse})
        }
    }

    getPreviouslyChecked(){
        const checkedCourse = this.props.form.courses.filter(courses => courses.canvas_course_id===this.props.course.canvas_course_id)
        return checkedCourse.length>0;
    }

    handleCheck = (event, isInputChecked) => {
        if(isInputChecked) {
            this.props.setNewFields({
                type: ACTION_TYPES.SET_FIELDS.ADD_COURSE,
                payload: this.props.course
            })
            this.setState({checked: true});
        } else {
            this.props.setNewFields({
                type: ACTION_TYPES.SET_FIELDS.REMOVE_COURSE,
                payload: this.props.course
            })
            this.setState({checked: false});
        }
    };

    renderCheckbox() {
        return(<Checkbox onChange={this.handleCheck} checked={this.state.checked}/>);
    }

    render() {
        return (
            <div>
                {this.renderCheckbox()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {form: state.newAssessmentForm};
}

export default connect(mapStateToProps, actions)(CheckboxField);